import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row, Card, Button, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import * as XLSX from 'xlsx';
import SmallLoader from '../../../shared/components/SmallLoader';
import FilterHeader from '../../../shared/components/FilterHeader';
import ResizableDataTable from './components/ResizableReactTable';
import CreateTableData from '../CreateData';
import { getProducteDetails, handleLoader } from '../../../redux/actions/productAction';
// import ExcelImport from './components/ExcelImport';
// import history from '../../App/History';


export const setCurrencyFormat = value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
const ResizableTable = ({ dispatch }) => {
  const { t } = useTranslation('common');
  const location = useLocation();
  const navigate = useNavigate();
  const [productdata, setData] = useState([]);
  const [setModel] = useState(false);
  const reactTableData = CreateTableData();
  const { productData, isLoading, salesChannelFilterData } = useSelector(
    ({ productReducer, marketPlaceReducer }) =>
    ({
      productData: productReducer.productData, isLoading: productReducer.isLoading,
      salesChannelFilterData: marketPlaceReducer.salesChannel
    }),
  );

  const changeFilter = (val, Opt) => {
    if (val && val.length > 0) {
      if (
        productData &&
        productData.modal &&
        productData.modal.data &&
        productData.modal.data.length > 0 &&
        Opt !== 'Quarter'
      ) {
        setData(
          productData.modal.data.filter(
            x =>
              val &&
              val.length > 0 &&
              val.find(y => (y?.value?.toString() || '').toLowerCase() === x[Opt]?.toLowerCase()),
          ),
        );
      }
    } else {
      setData(productData?.modal?.data ?? []);
    }
  };

  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: { top: 120, fontWeight: "bold" },
        maxCount: 10
      });
    });
    const dvTb = document.getElementById('dvTable');
    const dvChartF = document.getElementById('btnProductDownload');
    dvTb.style.display = "none";
    dvChartF.style.display = "none";
    const element = container.current || document.body;

    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
      // margin: "2cm",
      // forcePageBreak: ".page-break",
      //   landscape: true,
      //  multiPage: true,
      fileName: `Products Report ${new Date().getFullYear()}`,
    })
    dvTb.style.display = "block";
    dvChartF.style.display = "block";
  }

  useEffect(() => {
    dispatch(getProducteDetails());
  }, []);

  useEffect(() => {
    setData(productData && productData.modal && productData.modal.data || []);
  }, [productData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    if (salesChannelFilterData && salesChannelFilterData.length > 0) {
      if (
        productData?.modal?.data?.length > 0
      ) {
        setData(
          productData.modal.data.filter(
            x =>
              salesChannelFilterData?.length > 0 &&
              salesChannelFilterData?.find(y => (y?.value?.toString() || '')?.toLowerCase()
                === x[OptChennel]?.toLowerCase()),
          ),
        );
      }
    } else {
      setData(productData && productData.modal && productData.modal.data || []);
    }
  }, [productData, salesChannelFilterData])

  const openModel = () => {
    setModel(true);
  };

  const uploadExcel = () => {
    console.log('')
    navigate('/upload/product')
  }

  const formatedProductData = productdata?.map(item =>
    ({ ...item, cogs: !item.cogs || item.cogs === 'null' ? "" : item.cogs }))

  const exportToExcel = () => {
    try {
      // Show loading notification
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Preparing Excel file...',
          duration: 3,
          style: { top: 120, fontWeight: "bold" },
          maxCount: 10
        });
      });

      // Prepare data for export
      const exportData = formatedProductData.map(item => ({
        SKU: item.key || '',
        Title: item.prouctName || '',
        Cogs: item.cogs || '',
        Collection: item.productCollection || '',
        Category: item.productCategory || '',
        SubCategory: item.productSubCategory || ''
      }));

      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Set column widths for better formatting
      const columnWidths = [
        { wch: 12 }, // DATE
        { wch: 15 }, // BUNDLE_ASIN
        { wch: 50 }, // TITLE
        { wch: 15 }, // BUNDLES_SOLD
        { wch: 15 }, // TOTAL_SALES
      ];
      worksheet['!cols'] = columnWidths;

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Product');

      // Generate filename with current date
      const currentDate = new Date().toISOString().split('T')[0];
      const filename = `Product_${currentDate}.xlsx`;

      // Save the file
      XLSX.writeFile(workbook, filename);

      // Show success notification
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Excel file downloaded successfully!',
          duration: 3,
          style: { top: 120, fontWeight: "bold", color: 'green' },
          maxCount: 10
        });
      });

    } catch (error) {
      console.error('Error exporting to Excel:', error);
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Error exporting to Excel. Please try again.',
          duration: 5,
          style: { top: 120, fontWeight: "bold", color: 'red' },
          maxCount: 10
        });
      });
    }
  };




  return (
    <Container>
      <Row>
        <Col md={9}>
          <h3 className="page-title">{t('Products')}</h3>
          {/* <h3 className="page-subhead subhead"> Details of products.
          </h3> */}
        </Col>
      </Row>
      <Card className="pb-3">
        <CardBody className="card-shadow p-3">
          <Row>
            <Col sm='10'>
              <FilterHeader
                filter={productData && productData.modal && productData.modal.filters}
                callback={changeFilter}
                headerTitle={t('Products')}
              />
            </Col>
            <Col sm='2' className='text-right'>
              <button className="btn btn-sm btn-primary
                                             apply-date-button" style={{ marginTop: 55, marginRight: 5 }} type="button"
                title='Export to pdf' disabled={isLoading}
                onClick={exportToPDF}>Export PDF</button>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <div id="divToPrint" ref={container}>
        <Row className="product-table-wrap">
          <div className="ExcelTable" id='dvTable'>
            <Button
              disabled={!formatedProductData.length}
              className="download-monthly-sub-order-report btn-primary btn btn-sm mt-3 me-4"
              onClick={exportToExcel}
            >
              Download
            </Button>

          </div>

          <Col>

            <CardBody className="p-2">
              <Button id='btnProductDownload' className="btn btn-sm btn-primary" style={{
                marginTop: 10, marginLeft: 15,
                color: 'white'
              }} onClick={uploadExcel}>Upload Excel</Button>
              {isLoading ? <div style={{ minHeight: '200px' }}
                className="row align-items-center justify-content-center">
                <SmallLoader loading={isLoading} />
              </div>
                :
                <ResizableDataTable
                  reactTableData={reactTableData}
                  data={formatedProductData}
                />}
            </CardBody>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

ResizableTable.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect()(ResizableTable);
